import PropTypes from "prop-types";

const TimeoutNotice = ({ message, onRefresh, isLoading, canRefresh }) => {
  if (!message) {
    return null;
  }

  return (
    <div className="response bot timeout-error timeout-notice-container">
      <div className="timeout-message">
        <p>{message}</p>
        {canRefresh && (
          <button
            className="refresh-button"
            onClick={onRefresh}
            disabled={isLoading}
            aria-label="Refresh conversation"
            title="Refresh conversation"
          >
            <svg
              className="refresh-icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M20 12a8 8 0 1 1-2.343-5.657M20 4v5h-5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

TimeoutNotice.propTypes = {
  message: PropTypes.string,
  onRefresh: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  canRefresh: PropTypes.bool.isRequired,
};

export default TimeoutNotice;
